import React from 'react';

export default class MerchantCard extends React.Component {


  render() {
    const { merchant: { business_name: businessName } } = this.props;
    const { merchant: { display_name: displayName } } = this.props;
    const { merchant: { mid, totalMids } } = this.props;
    const { merchant: { acl_role_name: aclRoleName } } = this.props;
    return <div className="merchant-card">
      <div className="heading-container">
        <div className="card-heading">
          { businessName ? 'Business Name': 'Display Name' }
        </div>
        <div className="card-subheading">
        { businessName ? businessName: displayName}
        </div>
      </div>
      <div className="info-container">
        <div className="text-heading">
          MID
        </div>
        <div className="text">
          {mid} {totalMids > 1 ? `+${totalMids - 1} more`: ''}
        </div>
        <div className="text-heading">
          Role
        </div>
        <div className="text">
          {aclRoleName === 'MerchantAdminUserRole' ? 'Owner': aclRoleName}
        </div>
      </div>
    </div>;
  }
}
